/** Saved run-scoped profile projection. These values are recorded construction context, not inferred shopper facts. */
import * as z from 'zod';
const field = z.object({ label: z.string(), value: z.string(), source: z.string().nullable() }).strict();
export const savedRespondentProfileSchema = z
    .object({
    heading: z.string(),
    notice: z.string(),
    name: z.string(),
    respondentId: z.string(),
    populationId: z.string(),
    fields: z.array(field),
    context: z.array(field),
    provenance: z.array(z.object({ label: z.string(), value: z.string() }).strict()),
    limitations: z.array(z.string()),
})
    .strict();
export const resultSourceLabelsSchema = z
    .object({
    answer: z.string(),
    conversation: z.string(),
    profile: z.string(),
    unavailableProfile: z.string(),
    close: z.string(),
    details: z.string(),
    context: z.string(),
    provenance: z.string(),
    limitations: z.string(),
})
    .strict();
//# sourceMappingURL=response-source-profile.js.map